import moment from "moment-timezone";
import { CommonDestinationTimezone } from "@/lib/api/utils";
import { OtcLayerInvoiceFeeInfo } from "@/lib/api/otc";

function fmtDate(value: string | null): string {
  if (!value) return "—";
  const m = moment.tz(value, CommonDestinationTimezone);
  return m.isValid() ? m.format("MM/DD/YYYY") : "—";
}

export function LayerInvoiceFeeInfo({
  info,
}: {
  info: OtcLayerInvoiceFeeInfo;
}) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-semibold uppercase text-muted-foreground">
        Invoice Info
      </span>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-2">
        <div className="flex flex-col">
          <span className="text-xs text-muted-foreground">Paid</span>
          <span className="text-sm">{info.has_been_paid ? "Yes" : "No"}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs text-muted-foreground">Invoice #</span>
          <span className="text-sm">
            {info.invoice_number.trim() !== "" ? info.invoice_number.trim() : "—"}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs text-muted-foreground">Invoice Date</span>
          <span className="text-sm">{fmtDate(info.invoice_date)}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs text-muted-foreground">Date Marked</span>
          <span className="text-sm">{fmtDate(info.date_marked)}</span>
        </div>
      </div>
    </div>
  );
}
